import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-wageedit',
  templateUrl: './wageedit.component.html',
  styleUrls: ['./wageedit.component.scss']
})
export class WageeditComponent implements OnInit {

  data: any = {};

  constructor(
    public dialogRef: MatDialogRef<WageeditComponent>,
    @Inject(MAT_DIALOG_DATA) public incomingData: any,
    private apiService: ApiService,
    private snackBar: MatSnackBar
  ) {
    this.data = { ...incomingData.wage };
  }

  ngOnInit(): void {}

  onCancel(): void {
    this.dialogRef.close();
  }

  updateWage(): void {
    this.apiService.updateWage(this.data).subscribe(
      res => {
        this.snackBar.open('Wage updated successfully', 'Close', { duration: 3000 });
        this.dialogRef.close('updated');
      },
      err => {
        this.snackBar.open('Update failed', 'Close', { duration: 3000 });
      }
    );
  }
}
